import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { SearchSettingsFooter } from "@/Common/Components/Settings/SearchSettingsFooter";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IExternalMessageOutboxSettingsContainerProps {
    onSave: (settings: ExternalMessageOutboxSettingsContainerState) => void;
    onCancelClick: () => void;
    saveState: ExternalMessageOutboxSettingsContainerState;
}

class ExternalMessageOutboxSettingsContainerState {
    public receivedDateFrom: Date;
    public receivedDateTo: Date;
    public sendDateFrom: Date;
    public sendDateTo: Date;
    public selectedPageSizeOption: number;

    public static createDefault(): ExternalMessageOutboxSettingsContainerState {
        let state = new ExternalMessageOutboxSettingsContainerState();
        state.selectedPageSizeOption = 50;
        state.receivedDateFrom = null;
        state.receivedDateTo = null;
        state.sendDateFrom = null;
        state.sendDateTo = null;

        return state;
    }
}

class ExternalMessageOutboxSettingsContainer extends BaseReactComponent<IExternalMessageOutboxSettingsContainerProps, ExternalMessageOutboxSettingsContainerState> {
    constructor(props: IExternalMessageOutboxSettingsContainerProps) {
        super(props);

        this.state = {
            selectedPageSizeOption: props.saveState.selectedPageSizeOption,
            receivedDateFrom: props.saveState.receivedDateFrom,
            receivedDateTo: props.saveState.receivedDateTo,
            sendDateFrom: props.saveState.sendDateFrom,
            sendDateTo: props.saveState.sendDateTo
        };
    }

    public componentDidMount(): void {
        this.addHandle(LocalOperations.Misc.MyleApp_Container_Click, () => this.props.onSave(this.state));
        this.setOverlay("ExternalMessageOutboxSettingsContainer", { transparent: true });
    }

    public render(): JSX.Element {
        const isSenDateValid = (this.state.sendDateFrom && this.state.sendDateTo) && (moment(this.state.sendDateFrom) < moment(this.state.sendDateTo));
        const isReceivedDateValid = (this.state.receivedDateFrom && this.state.receivedDateTo) && (moment(this.state.receivedDateFrom) < moment(this.state.receivedDateTo));

        return (
            <div className="filter-component" style={{ width: "650px" }} onClick={e => e && e.stopPropagation()}>
                <table className="f-content">
                    <thead>
                        <tr>
                            <th className="first">
                                <label className="uppercase">{cacheStore.GetString("SentDateLabel")}</label>
                            </th>
                            <th className="first">
                                <label className="uppercase">{cacheStore.GetString("ReceivedDateLabel")}</label>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className="first">
                                <div style={{ maxWidth: "230px" }}>
                                    <DateSelector
                                        id="xcomSendDateFrom"
                                        date={this.state.sendDateFrom}
                                        onChangeCallback={date => this.mutateState(s => s.sendDateFrom = date && moment(date).startOf("day").toDate())}
                                        dateFormat="yyyy-MM-dd"
                                        disabled={false}
                                        toDayEnabled={true}
                                        valid={isSenDateValid && moment(this.state.sendDateFrom).isValid()}
                                    />

                                    <DateSelector
                                        id="xcomSendDateTo"
                                        date={this.state.sendDateTo}
                                        onChangeCallback={date => this.mutateState(s => s.sendDateTo = date && moment(date).endOf("day").toDate())}
                                        dateFormat="yyyy-MM-dd"
                                        disabled={false}
                                        toDayEnabled={true}
                                        valid={isSenDateValid && moment(this.state.sendDateTo).isValid()}
                                    />
                                </div>
                            </td>
                            <td className="first">
                                <div style={{ maxWidth: "230px" }}>
                                    <DateSelector
                                        id="xcomReceiveDateFrom"
                                        date={this.state.receivedDateFrom}
                                        onChangeCallback={date => this.mutateState(s => s.receivedDateFrom = date && moment(date).startOf("day").toDate())}
                                        dateFormat="yyyy-MM-dd"
                                        disabled={false}
                                        toDayEnabled={true}
                                        valid={isReceivedDateValid && moment(this.state.receivedDateFrom).isValid()}
                                    />

                                    <DateSelector
                                        id="xcomReceiveDateTo"
                                        date={this.state.receivedDateTo}
                                        onChangeCallback={date => this.mutateState(s => s.receivedDateTo = date && moment(date).endOf("day").toDate())}
                                        dateFormat="yyyy-MM-dd"
                                        disabled={false}
                                        toDayEnabled={true}
                                        valid={isReceivedDateValid && moment(this.state.receivedDateTo).isValid()}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <SearchSettingsFooter
                    onClose={() => this.props.onCancelClick()}
                    onOk={() => this.props.onSave(this.state)}
                    onResultsPerPageChange={size => this.mutateState(s => s.selectedPageSizeOption = size)}
                    selectedPageSizeOption={this.state.selectedPageSizeOption}
                />
            </div>
        );
    }
}

export { ExternalMessageOutboxSettingsContainer, ExternalMessageOutboxSettingsContainerState };
